<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="pull-left">
        <h5>
          Timeline
        </h5>
      </div>

      <div class="pull-right">
        <div class="btn-group" style="margin-top: 4px">
          <button type="button" class="btn btn-black btn-sm dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-plus"></i> Add <span class="caret"></span>
          </button>

          <ul class="dropdown-menu">
            <li>
              <a href="#create-comment-modal" data-toggle="modal">
                <i class="fa fa-comment"></i> Create Comment
              </a>
            </li>

            <li>
              <a href="#create-reminder-modal" data-toggle="modal">
                <i class="fa fa-bell"></i> Create Reminder
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>

    <loading-spinner v-if="loading"></loading-spinner>

    <ul v-else class="list-group">
      <li class="list-group-item" v-for="logLine in slicedLogLines" style="position: relative;">
        <div class="pull-left">
          <log-line-headline :log-line="logLine"></log-line-headline>
        </div>

        <div class="pull-right">
          <log-line-actions
              :log-line="logLine"
              @edit="edit(logLine)"
              @resolve="resolve(logLine)"
              @postpone="postpone(logLine)"
          ></log-line-actions>
        </div>

        <div class="clearfix"></div>

        <log-line-content :log-line="logLine"></log-line-content>

        <br>

        <log-line-footer :log-line="logLine"></log-line-footer>

        <button @click="toggleSticky(logLine)" class="dashboard-sticky-button"
                :class="{'dashboard-sticky-button-selected': logLine.is_sticky}">
          <i class="fa fa-sticky-note"></i>
        </button>
      </li>

      <li class="list-group-item">
        <router-link :to="company.data.id +'/timeline'">
          Show more...
        </router-link>
      </li>
    </ul>

    <CreateCommentModal :subject="company" @created="load"/>

    <CreateReminderModal :subject="company" @created="load"/>

    <PostponeReminderModal :reminder="editing" @postponed="load" data-name="timeline"/>

    <UpdateReminderModal :reminder="editing" @updated="load" data-name="timeline"/>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import CreateCommentModal from '@/pages/Shared/Modals/CreateComment'
import CreateReminderModal from '@/pages/Shared/Modals/CreateReminder'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import LogLineContent from '@/components/LogLine/LogLineContent'
import LogLineFooter from '@/components/LogLine/LogLineFooter'
import LogLineHeadline from '@/components/LogLine/LogLineHeadline'
import LogLineUser from '@/components/LogLine/LogLineUser'
import LogLineActions from '@/components/LogLine/LogLineActions'
import PostponeReminderModal from '@/components/Modals/Reminders/PostponeReminderModal'
import UpdateReminderModal from '@/pages/Shared/Modals/UpdateReminder'

export default {
  components: {
    LogLineActions,
    CreateCommentModal,
    CreateReminderModal,
    LoadingSpinner,
    LogLineContent,
    LogLineFooter,
    LogLineHeadline,
    LogLineUser,
    PostponeReminderModal,
    UpdateReminderModal
  },

  props: ['company'],

  data() {
    return {
      loading: true,
      logLines: null,
      editing: null
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    slicedLogLines() {
      return this.logLines.data.slice(0, 5)
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v1/log-lines', {
        'owner[id]': this.company.data.id,
        'owner[type]': 'companies',
        'event': 'comment-created,reminder-created'
      })
          .then(response => {
            this.logLines = response.data

            this.loading = false
          })
    },

    edit(logLine) {
      this.editing = {id: logLine.subject.id, attributes: logLine.subject}

      $('#update-reminder-modal[data-name=timeline]').modal('show')
    },

    resolve(logLine) {
      modal.confirm('Are you sure that you want to resolve the reminder?', ()=> {
        http.post('/api/v2/reminders/' + logLine.subject.id + '/resolve')
            .then(() => {
              notify.success('The reminder was resolved')

              this.load()
            })
      })
    },

    postpone(logLine) {
      this.editing = {id: logLine.subject.id, attributes: logLine.subject}

      $('#postpone-reminder-modal[data-name=timeline]').modal('show')
    },

    toggleSticky(logLine) {
      http.put('/api/v1/log-lines/' + logLine.id, {is_sticky: !logLine.is_sticky})
          .then(() => notify.success('The log line was made sticky'))
          .then(this.load)
    }
  }
}
</script>

<style>
.dashboard-sticky-button {
  position: absolute;
  bottom: 5px;
  right: 5px;
  font-size: 12px;
  background: transparent;
  border: none;
  padding: 0;
  line-height: 12px;
  opacity: 0.5;
}

.dashboard-sticky-button-selected {
  opacity: 1;
}
</style>
